module.exports = __webpack_public_path__ + "img/check.45666610.png";